import { Player } from '@lottiefiles/react-lottie-player'
import { Button, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ErrorBoundaryMechanic from '../lottie/error-boundary-mechanic.json' // lottie animation

const ErrorFallback = () => {
  const { t } = useTranslation()

  return (
    <div>
      <Grid
        alignContent="center"
        alignItems="center"
        container
        direction="column"
        sx={{
          p: 2,
        }}
      >
        <Typography variant="h5">{t('errors.went_wrong')}</Typography>

        <Player
          autoplay
          loop
          src={ErrorBoundaryMechanic}
          style={{ height: '300', width: 'auto' }}
        />
        <Button
          disableElevation
          onClick={window.location.reload}
          variant="contained"
        >
          {t('errors.reload_page')}
        </Button>
        <br />
      </Grid>
    </div>
  )
}

export default ErrorFallback
